export const WA_LOG_TYPES = {
	WA_CREATED: 'waCreated',
	WA_ACTUAL_CREATED: 'waActualCreated',
	WA_STATUS_UPDATED: 'waStatusUpdated',
	WA_TIME_UPDATED: 'waTimeUpdated',
	WA_BREAKDOWN: 'waBreakdown',
};

export const ACTION_TYPE_LABELS = {
	waCreated: 'Assignment created',
	waStatusUpdated: 'Assignment status updated',
	waTimeUpdated: 'Assignment time updated',
	waActualCreated: 'Assignment reconciled',
	waBreakdown: 'Assignment breakdown',
	crewMemberAbsenceCreated: 'Absence added',
	crewMemberAbsenceUpdated: 'Absence updated',
	crewMemberAbsenceDeleted: 'Absence removed',
	crewMemberInfoUpdated: 'Info updated',
	crewMemberHomeBaseCreated: 'Home base added',
	crewMemberHomeBaseUpdated: 'Home base updated',
	crewMemberHomeBaseDeleted: 'Home base removed',
	crewMemberEmploymentCreated: 'Employment added',
	crewMemberEmploymentUpdated: 'Employment updated',
	crewMemberEmploymentDeleted: 'Employment removed',
	crewMemberHoldDownCreated: 'Hold-down created',
	crewMemberHoldDownUpdated: 'Hold-down updated',
	crewMemberHoldDownDeleted: 'Hold-down removed',
	crewMemberLocationChangeCreated: 'Location change added',
	crewMemberLocationChangeUpdated: 'Location change updated',
	crewMemberLocationChangeDeleted: 'Location change removed',
};

export const TYPE_TO_CATEGORY = {
	waCreated: 'assignment',
	waStatusUpdated: 'assignment',
	waTimeUpdated: 'assignment',
	waActualCreated: 'assignment',
	waBreakdown: 'breakdown',
	crewMemberAbsenceCreated: 'absence',
	crewMemberAbsenceUpdated: 'absence',
	crewMemberAbsenceDeleted: 'absence',
	crewMemberInfoUpdated: 'info',
	crewMemberHomeBaseCreated: 'base',
	crewMemberHomeBaseUpdated: 'base',
	crewMemberHomeBaseDeleted: 'base',
	crewMemberEmploymentCreated: 'info',
	crewMemberEmploymentUpdated: 'info',
	crewMemberEmploymentDeleted: 'info',
	crewMemberHoldDownCreated: 'holdDown',
	crewMemberHoldDownUpdated: 'holdDown',
	crewMemberHoldDownDeleted: 'holdDown',
	crewMemberLocationChangeCreated: 'info',
	crewMemberLocationChangeUpdated: 'info',
	crewMemberLocationChangeDeleted: 'info',
};
